export default function immutable<T extends Record<any, any> | Array<any>>(item: T): Readonly<T> {
    const result: any = item;
    if (result != null && typeof result === 'object') {
        Object.keys(result).forEach((key) => {
            if (
                result.hasOwnProperty &&
                result.hasOwnProperty(key) &&
                typeof item === 'object' &&
                Object.getOwnPropertyDescriptor(result, key)?.writable === true
            ) {
                result[key] = immutable(result[key]);
            }
        });
    }

    return Object.freeze<T>(result as T);
}
